import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { Picking } from "interfaces/picking";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_PICKINGS_" }
);

export interface ListPickingsState extends IState {
  data: Picking[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: Picking[];
}

const INITIAL_STATE: ListPickingsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListPickingsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListPickingsState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListPickingsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listPickings = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListPickingsTypes = Types;
export const ListPickingsActions = Creators;
